import React from "react";
import { cn, buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";

import * as styles from "./carousel-figure.module.css";

export function CarouselFigure({ node }) {
  if (!node.asset) {
    return null;
  }

  return (
    <figure className={styles.root}>
      <img
        src={imageUrlFor(buildImageObj(node))
          .width(1440)
          .url()}
        alt={node.alt}
      />
    </figure>
  );
}